import { TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { SelectModel } from '@shared/components/select/models/select';
import { CatalogType } from '@shared/models/shared-catalog.state';

type CatalogColumns = {
  name: string;
  title: string;
  type: CatalogType;
  order: number;
  dictionaryId?: number;
  systemField?: string;
  system?: boolean;
  isPk?: boolean;
  catalogId: number;
  calculationWidth: number;
};

export type CatalogStaticColumns = {
  columnContent?: TemplateRef<any>;
} & CatalogColumns;

export type CatalogDynamicColumns = {
  show: boolean;
  imageInfo: Observable<{
    isImage: boolean;
    isSvg: boolean;
  }> | null;
  searchValue?: string;
  catalogColumns?: CatalogDynamicColumns[];
} & CatalogColumns;

export type CatalogItemsQueryParams = {
  access?: string;
  objectId?: number;
  pageIndex?: number;
  pageSize?: number;
  filter?: string;
  isDynamic?: string;
  isRecommendationData?: string;
  version?: number;
  release?: number;
};

export class SearchCatalogItem {
  constructor(
    public searchValue: string,
    public type: CatalogType,
    public name: string,
    public title: string,
    public dictionaryValues?: Observable<SelectModel[]>,
    public dictionaryId?: number,
    public loading?: boolean,
    public isBigTitle?: boolean,
    public isMultiple = false,
  ) {}
}
